/**
 * Real-time streaming implementation using XMLHttpRequest
 * This bypasses browser buffering issues with fetch streams
 */

class RealTimeStreamer {
    constructor() {
        this.xhr = null;
        this.processingPosition = 0;
        this.buffer = '';
        this.onChunk = null;
        this.onComplete = null;
        this.onError = null;
    }

    startStream(url, data, callbacks) {
        this.onChunk = callbacks.onChunk;
        this.onComplete = callbacks.onComplete;
        this.onError = callbacks.onError;
        
        this.xhr = new XMLHttpRequest();
        this.xhr.open('POST', url, true);
        this.xhr.setRequestHeader('Content-Type', 'application/json');
        this.xhr.setRequestHeader('Cache-Control', 'no-cache');
        
        let lastProcessedIndex = 0;
        
        this.xhr.onreadystatechange = () => {
            if (this.xhr.readyState >= 3) { // LOADING state
                const newText = this.xhr.responseText.substring(lastProcessedIndex);
                lastProcessedIndex = this.xhr.responseText.length;
                
                if (newText) {
                    console.log('⚡ Real-time chunk received:', newText.length, 'chars');
                    this.processChunk(newText);
                }
            }
            
            if (this.xhr.readyState === 4) { // DONE state
                console.log('🎯 Real-time streaming complete');
                if (this.onComplete) {
                    this.onComplete();
                }
            }
        };
        
        this.xhr.onerror = () => {
            console.error('❌ Real-time streaming error');
            if (this.onError) {
                this.onError(new Error('Streaming failed'));
            }
        };
        
        this.xhr.send(JSON.stringify(data));
    }
    
    processChunk(chunk) {
        this.buffer += chunk;
        
        // Process complete lines immediately
        let startPos = 0;
        let newlinePos = this.buffer.indexOf('\n', startPos);
        
        while (newlinePos !== -1) {
            const line = this.buffer.substring(startPos, newlinePos);
            
            if (line.startsWith('data: ')) {
                try {
                    const data = JSON.parse(line.slice(6));
                    console.log('⚡ INSTANT processing via XHR:', data.type);
                    
                    if (this.onChunk) {
                        this.onChunk(data);
                    }
                } catch (e) {
                    console.warn('Parse error in real-time chunk:', e);
                }
            }
            
            startPos = newlinePos + 1;
            newlinePos = this.buffer.indexOf('\n', startPos);
        }
        
        // Keep remaining incomplete line
        this.buffer = this.buffer.substring(startPos);
    }
    
    abort() {
        if (this.xhr) {
            this.xhr.abort();
            this.xhr = null;
        }
    }
}

// Export for use in ChatController
window.RealTimeStreamer = RealTimeStreamer;